
//Random utility functions

String.prototype.toProperCase = function () {
    return this.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
};

String.prototype.capitalize = function() {
    return this.charAt(0).toUpperCase() + this.slice(1);
}

function getCookie(name) {
    var cookieValue = null;
    if (document.cookie && document.cookie != '') {
        var cookies = document.cookie.split(';');
        for (var i = 0; i < cookies.length; i++) {
            var cookie = jQuery.trim(cookies[i]);
            // Does this cookie string begin with the name we want?
            if (cookie.substring(0, name.length + 1) == (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}

function getFieldValue(name) {
    var value = null;
    try {
        value = document.querySelectorAll('input[name=' + name + ']')[0].value
    }
    catch(err) {
        console.error('Unable to get field value.',name,err)
    }
    finally {
        return value;
    }
}

function isIEorEdge(){
    return navigator.appName == 'Microsoft Internet Explorer' || (navigator.appName == "Netscape" && navigator.appVersion.indexOf('Edge') > -1);
}

function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

function generateUUID() {
    var d = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (d + Math.random()*16)%16 | 0;
        d = Math.floor(d/16);
        return (c=='x' ? r : (r&0x3|0x8)).toString(16);
    });
    return uuid;
};

function XMLtoJSON(xml) {
	// Create the return object
	var obj = {};

	if (xml.nodeType == 1) { // element
		// do attributes
		if (xml.attributes.length > 0) {
		obj["@attributes"] = {};
			for (var j = 0; j < xml.attributes.length; j++) {
				var attribute = xml.attributes.item(j);
				obj["@attributes"][attribute.nodeName] = attribute.nodeValue;
			}
		}
	} else if (xml.nodeType == 3) { // text
		obj = xml.nodeValue;
	}

	// do children
	if (xml.hasChildNodes()) {
		for(var i = 0; i < xml.childNodes.length; i++) {
			var item = xml.childNodes.item(i);
			var nodeName = item.nodeName;
			if (typeof(obj[nodeName]) == "undefined") {
				obj[nodeName] = XMLtoJSON(item);
			} else {
				if (typeof(obj[nodeName].push) == "undefined") {
					var old = obj[nodeName];
					obj[nodeName] = [];
					obj[nodeName].push(old);
				}
				obj[nodeName].push(XMLtoJSON(item));
			}
		}
	}
	return obj;
};

function cleanJSONString(input){
    var json = input;
    json = json.replace('"', '\"'); //escape any quotes in the content
    json = json.replace(/\'/g, '"'); //replace single quotes that the stringify produces, not valid JSON
    var falseRe = /false/gi;
    var trueRe = /true/gi;
    var noneRe = /none/gi;
    json = json.replace(falseRe,'false');
    json = json.replace(trueRe,'true');
    json = json.replace(noneRe,'null');
    return json;
}

//Check if text is json string
function isJSON(text){
    if (typeof text!=="string"){
        return false;
    }
    try{
        JSON.parse(text);
        return true;
    }
    catch (error){
        return false;
    }
}

//plain js version of jquery extend
var extend = function(out) {
  out = out || {};

  for (var i = 1; i < arguments.length; i++) {
    if (!arguments[i])
      continue;

    for (var key in arguments[i]) {
      if (arguments[i].hasOwnProperty(key))
        out[key] = arguments[i][key];
    }
  }

  return out;
};

var deepExtend = function(out) {
  out = out || {};

  for (var i = 1; i < arguments.length; i++) {
    var obj = arguments[i];

    if (!obj)
      continue;

    for (var key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (typeof obj[key] === 'object')
          out[key] = deepExtend(out[key], obj[key]);
        else
          out[key] = obj[key];
      }
    }
  }

  return out;
};

//plain js alternative to jQuery $(document).ready()
function ready(fn) {
  if (document.attachEvent ? document.readyState === "complete" : document.readyState !== "loading"){
    fn();
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
};

//find the index of the nth instance of a character in a string (e.g. find the 3rd letter 'c')
function nthOcurrence(str, needle, nth) {
  for (i=0;i<str.length;i++) {
    if (str.charAt(i) == needle) {
        if (!--nth) {
           return i;
        }
    }
  }
  return false;
}

//get substring of path based on slash count
function getSubPath(sURL,nSlash) {
    var nIndex = nthOcurrence(sURL, "/", nSlash);
    return sURL.substring(nIndex);
}

/*function validateURL(sURL) {
    var format = new RegExp(/\b((?:https?:\/\/|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s()<>]+|\(([^\s()<>]+|(\([^\s()<>]+\)))*\))+(?:\(([^\s()<>]+|(\([^\s()<>]+\)))*\)|[^\s`!()\[\]{};:'".,<>?«»“”‘’]))$/i);
	return format.test(sURL);
}*/

function validateURL(sURL) {
    regexp =  /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
    return regexp.test(sURL);
}

// See http://rosskendall.com/blog/web/javascript-function-to-check-an-email-address-conforms-to-rfc822
function isEmail(email){
    return /^([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22))*\x40([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d))*$/.test( email );
}

function elementInViewport(el) {
    var top = el.offsetTop;
    var left = el.offsetLeft;
    var width = el.offsetWidth;
    var height = el.offsetHeight;

    while(el.offsetParent) {
        el = el.offsetParent;
        top += el.offsetTop;
        left += el.offsetLeft;
    }

    return (
        top < (window.pageYOffset + window.innerHeight) &&
        left < (window.pageXOffset + window.innerWidth) &&
        (top + height) > window.pageYOffset &&
        (left + width) > window.pageXOffset
    );
}

function isOdd(num) {
    return (num % 2) == 1;
}

function roundedDecimal(num,decimals){
    if(num == 0){
        return 0;
    } else {
        return Math.round(num*Math.pow(10,decimals))/Math.pow(10,decimals);
    }
}

function numberWithCommas(num){
  var parts = num.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
}

function getSpinnerHTML(){
    //return '<div class="spinner spinner--pulsing"><div class="spinner-ring"></div></div>';
    return '<div class="spinner"></div>';
}

function alertLoading(msg){
    var msg = msg || "";
    if(msg.length > 0){
        msg += " ";
    }
    alertify.delay(0).closeLogOnClick(false).loading(msg + getSpinnerHTML());
}

function removeLoading(){
    $(".loading",".alertify-logs").remove();
    alertify.reset();
}

//Deprecated onboarding functions
function showOnboarding(){
    $("header.header--onboarding").show().prev("header").hide(); //slide? animate?
}
function hideOnboarding(){
    $("header.header--onboarding").hide().prev("header").show(); //slide? animate?
}

var previewDomains = [
    'youtube',
    'slideshare',
    'facebook',
    'linkedin',
    'dribbble',
    'flickr',
    'git',
    'google',
    'medium',
    'pinterest',
    'tumblr',
    'vimeo',
    'dropbox',
    'onedrive',
    'behance',
    'codepen',
    'bitbucket',
    'bandcamp',
    'soundcloud',
    'simplybuilt'
];

var iconExt = [
    'doc',
    'docx',
    'xls',
    'xlsx',
    'ppt',
    'pptx',
    'pdf',
    'mp3',
    'm4a',
    'aac',
    'wav',
    'wma',
    'opus',
    'webm',
    'mp4',
    'mov',
    'mkv',
    'avi',
    'qt',
    'wmv',
    'f4v',
    'm4v',
    'ogg',
    'php',
    'js',
    'html',
    'css',
    'scss',
    'jsx',
    'py',
    'rb',
    'cs',
    'go',
    'vb',
    'aspx',
    'jv',
    'prl'
];

// Markdown parser
function ParseMarkdown(){
    if (typeof markdownit != "undefined") {
        var elements = document.querySelectorAll(".markdownit");
        Array.prototype.forEach.call(elements, function(el, i){
            var rawText = el.textContent;
            var markdown = new markdownit();
            var result = markdown.render(rawText);
            el.innerHTML = result;
            el.classList.remove("markdownit");
            el.classList.add("has-markdown");
        });
    } else {
        console.error('Markdown-It not loaded. Unable to parse markdown blocks.')
    }
}


// utilities for taxes for pre-screening. Actual calculation happens the backend for security reasons
function getTaxesFromPostal(postal){
    var postal = postal.toUpperCase();
	if(postal.length > 0){
      	first = postal.substring(0, 1);
        var taxes = {
            tax_location: "",
            tax_type: "",
            tax_rate: 0
        }
        CA_provinces.forEach(function(element) {
        	if(tax_rates.CA[element].postal_prefixes.indexOf(first) > -1){
            taxes.tax_location = tax_rates.CA[element].name;
            taxes.tax_type = tax_rates.CA[element].tax_type;
            taxes.tax_rate = tax_rates.CA[element].tax_rate;
          }
        });
        return taxes;
    } else {
        console.error("Please pass a non-empty postal code.");
      	return false;
    }
}

function getTaxesFromCountry(countrycode){
    var countrycode = countrycode.toUpperCase();
    if(countrycode == "CA"){
        //console.error("You must look up Canadian tax rates by postal code.")
        return false;
    } else if(countrycode.length > 0){
        if(tax_rates[countrycode] != undefined){
            var taxes = {
                tax_location: tax_rates[countrycode].name,
                tax_type: tax_rates[countrycode].tax_type,
                tax_rate: tax_rates[countrycode].tax_rate
            }
            return taxes;
        } else {
            return false;
        }

    } else {
        console.error("Please pass a non-empty country code.");
      	return false;
    }
}

//some countries have two codes so this is a shortcut function
function countriesMatch(codeA, codeB) {
    var codeA = codeA.toUpperCase();
    var codeB = codeB.toUpperCase();
    if(codeA == codeB){
        return true;
    } else {
        if (codeA == "EL" || codeA == "GR") {
            if (codeB == "EL" || codeB == "GR") {
                return true;
            }
        }
        if (codeA == "UK" || codeA == "GB") {
            if (codeB == "UK" || codeB == "GB") {
                return true;
            }
        }
        return false;
    }
}

var CA_provinces = ["AB","BC","MB","NB","NL","NS","NT","NU","ON","QC","SK","YT","PE"];

var tax_rates = {
    //Australia
    AU: {
        name: "Australia",
        tax_type: "GST",
        tax_rate: 0.10
    },
    //Canada
    CA: {
        AB: {
            name: "Alberta",
            postal_prefixes: "T",
            tax_type: "GST",
            tax_rate: 0.05
        },
        BC: {
            name: "British Columbia",
            postal_prefixes: "V",
            tax_type: "GST",
            tax_rate: 0.05
        },
        MB: {
            name: "Manitoba",
            postal_prefixes: "R",
            tax_type: "GST",
            tax_rate: 0.05
        },
        NB: {
            name: "New Brunswick",
            postal_prefixes: "E",
            tax_type: "HST",
            tax_rate: 0.15
        },
        NL: {
            name: "Newfoundland & Labrador",
            postal_prefixes: "A",
            tax_type: "HST",
            tax_rate: 0.15
        },
        NS: {
            name: "Nova Scotia",
            postal_prefixes: "B",
            tax_type: "HST",
            tax_rate: 0.15
        },
        NT: {
            name: "Northwest Territories",
            postal_prefixes: "X",
            tax_type: "GST",
            tax_rate: 0.05
        },
        NU: {
            name: "Nunavut",
            postal_prefixes: "X",
            tax_type: "GST",
            tax_rate: 0.05
        },
        ON: {
            name: "Ontario",
            postal_prefixes: "KLMNP",
            tax_type: "HST",
            tax_rate: 0.13
        },
        QC: {
            name: "Quebec",
            postal_prefixes: "GHJ",
            tax_type: "GST",
            tax_rate: 0.05
        },
        SK: {
            name: "Saskatchewan",
            postal_prefixes: "S",
            tax_type: "GST",
            tax_rate: 0.05
        },
        YT: {
            name: "Yukon Territory",
            postal_prefixes: "Y",
            tax_type: "GST",
            tax_rate: 0.05
        },
        PE: {
            name: "Prince Edward Island",
            postal_prefixes: "C",
            tax_type: "HST",
            tax_rate: 0.15
        }
    },

    //European Union States
    //Note that there are two entries each for Greece and United Kingdom
    //due to an inconsistency in use around the world/across organizations
    AT: {
        name: "Austria",
        tax_type: "VAT",
        tax_rate: 0.20
    },
    BE: {
        name: "Belgium",
        tax_type: "VAT",
        tax_rate: 0.21
    },
    BG: {
        name: "Bulgaria",
        tax_type: "VAT",
        tax_rate: 0.20
    },
    HR: {
        name: "Croatia",
        tax_type: "VAT",
        tax_rate: 0.25
    },
    CY: {
        name: "Republic of Cyprus",
        tax_type: "VAT",
        tax_rate: 0.19
    },
    CZ: {
        name: "Czech Republic",
        tax_type: "VAT",
        tax_rate: 0.21
    },
    DK: {
        name: "Denmark",
        tax_type: "VAT",
        tax_rate: 0.25
    },
    EE: {
        name: "Estonia",
        tax_type: "VAT",
        tax_rate: 0.20
    },
    FI: {
        name: "Finland",
        tax_type: "VAT",
        tax_rate: 0.24
    },
    FR: {
        name: "France",
        tax_type: "VAT",
        tax_rate: 0.20
    },
    DE: {
        name: "Germany",
        tax_type: "VAT",
        tax_rate: 0.19
    },
    EL: {
        name: "Greece",
        tax_type: "VAT",
        tax_rate: 0.24
    },
    GR: {
        name: "Greece",
        tax_type: "VAT",
        tax_rate: 0.24
    },
    HU: {
        name: "Hungary",
        tax_type: "VAT",
        tax_rate: 0.27
    },
    IE: {
        name: "Ireland",
        tax_type: "VAT",
        tax_rate: 0.23
    },
    IT: {
        name: "Italy",
        tax_type: "VAT",
        tax_rate: 0.22
    },
    LV: {
        name: "Latvia",
        tax_type: "VAT",
        tax_rate: 0.21
    },
    LT: {
        name: "Lithuania",
        tax_type: "VAT",
        tax_rate: 0.21
    },
    LU: {
        name: "Luxembourg",
        tax_type: "VAT",
        tax_rate: 0.17
    },
    MT: {
        name: "Malta",
        tax_type: "VAT",
        tax_rate: 0.18
    },
    NL: {
        name: "Netherlands",
        tax_type: "VAT",
        tax_rate: 0.21
    },
    PL: {
        name: "Poland",
        tax_type: "VAT",
        tax_rate: 0.23
    },
    PT: {
        name: "Portugal",
        tax_type: "VAT",
        tax_rate: 0.23
    },
    RO: {
        name: "Romania",
        tax_type: "VAT",
        tax_rate: 0.19
    },
    SK: {
        name: "Slovakia",
        tax_type: "VAT",
        tax_rate: 0.20
    },
    SI: {
        name: "Slovenia",
        tax_type: "VAT",
        tax_rate: 0.22
    },
    ES: {
        name: "Spain",
        tax_type: "VAT",
        tax_rate: 0.21
    },
    SE: {
        name: "Sweden",
        tax_type: "VAT",
        tax_rate: 0.25
    },
    UK: {
        name: "United Kingdom",
        tax_type: "VAT",
        tax_rate: 0.20
    },
    GB: {
        name: "United Kingdom",
        tax_type: "VAT",
        tax_rate: 0.20
    }

}

var vatlayerKey = '245543066f23c390c4fc325759f63478';

function validateVAT(sVAT){
    httpGetExternal('http://apilayer.net/api/validate' + formatParams({
        access_key: vatlayerKey,
        vat_number: sVAT,
        format: 1
    })).then(
        function(value) {
            var response = JSON.parse(value);
            return response;
        })
    .catch(
        function(reason) {
            console.error('Error trying to validate VAT number', reason);
            alertify.error("Error trying to validate VAT number")
        });
}
// moved up to here

function getOrganizationLimitStatus(target,pending){
    var nPending = pending || null;
    httpGet(buildRoute(mantlroutes.org_about,{ "orgid": mantl.orgid })).then(
        function(value) {
            var response = JSON.parse(value);
            response.pending = nPending;
            var hbstemplate = mantlhbs.organization.earnerlimit;
            var output = hbstemplate(response);
            $(target).html(output);
            $('[data-popover="tooltip"]', target).tooltip();
        })
    .catch(
        function(reason) {
            console.error('Error loading org info.', reason);
        });

}
